/**
 * @typedef {object} OptionenKonfigurationen
 * @property {string} titel
 * @property {string} faKlassen
 * @property {string} color
 * @property {string} backColor
 * @property {bool} [nurMobil]
 * @property {(url: string, titel, string) => string} shareUrl
 */

(() => {
	'use strict';
	/** @type {Record<string, OptionenKonfigurationen} */
	const optionenKonfigurationen = {
		whatsapp: {
			titel: 'Bei WhatsApp teilen',
			faKlassen: 'fa-brands fa-whatsapp',
			color: 'white',
			backColor: '#25D366', // 5CBE4A
			nurMobil: true,
			shareUrl: (url, titel) => `whatsapp://send?text=${titel}%20${url}`,
		},
		telegram: {
			titel: 'Bei Telegram teilen',
			faKlassen: 'fa-brands fa-telegram',
			color: 'white',
			backColor: '#24A1DE', // 0088CC
			nurMobil: true,
			shareUrl: url => `https://t.me/share/url?url=${url}`,
		},
		threema: {
			titel: 'Bei Threema teilen',
			faKlassen: 'fa-solid fa-lock',
			color: 'white',
			backColor: '#333333',
			nurMobil: true,
			shareUrl: (url, titel) => `threema://compose?text=${titel}%20${url}`,
		},
		xing: {
			titel: 'Bei Xing teilen',
			faKlassen: 'fa-brands fa-xing',
			color: 'white',
			backColor: '#0698A0', // 126567
			shareUrl: url => `https://www.xing.com/spi/shares/new?url=${url}`,
		},
		twitter: {
			titel: 'Bei X (ehem. Twitter) teilen',
			faKlassen: 'fa-brands fa-x-twitter',
			color: 'white',
			backColor: 'black',
			shareUrl: (url, titel) => `https://twitter.com/intent/tweet?text=${titel}&url=${url}`,
		},
		facebook: {
			titel: 'Bei Facebook teilen',
			faKlassen: 'fa-brands fa-facebook-f',
			color: 'white',
			backColor: '#3B5998',
			shareUrl: url => `https://www.facebook.com/sharer/sharer.php?u=${url}`,
		},
		print: {
			titel: 'Drucken',
			faKlassen: 'fa-solid fa-print',
			color: 'white',
			backColor: '#999',
		},
		email: {
			titel: 'Per E-Mail senden',
			faKlassen: 'fa-regular fa-envelope',
			color: 'white',
			backColor: '#999',
			shareUrl: (url, titel) => `mailto:?subject=${titel}&body=${url}`,
		},
		...'kunde' in window && 'teilenOptionenKonfigurationen' in window.kunde ? window.kunde.teilenOptionenKonfigurationen : {},
	};

	document.body.addEventListener('click', evt => {
		let elemAuslassen = null;
		/** @type {HTMLElement} */
		const target = evt.target;
		if (target.classList.contains('teilen-haupt-button')) {
			elemAuslassen = target.parentElement.querySelector('.teilen-liste');
		}
		else if (target.parentElement != null && target.parentElement.classList.contains('teilen-haupt-button')) {
			elemAuslassen = target.parentElement.parentElement.querySelector('.teilen-liste');
		}
		Array.from(document.querySelectorAll('.teilen-liste'))
			.filter(elem => elem !== elemAuslassen)
			.forEach(teilenListe => {
				teilenListe.classList.remove('show');
				teilenListe.ariaHidden = true;
				teilenListe.querySelectorAll('a').forEach(elem => {
					elem.tabIndex = -1;
				});
			});
	});

	/**
	 * @param {HTMLDivElement} elem Wrapper-Element mit data-Attriuten
	 * @param {OptionenKonfigurationen} optionenKonfiguration Netzwerk
	 * @returns {string} Href
	 */
	function getTeilenLink(elem, optionenKonfiguration) {
		const titel = encodeURIComponent(elem.dataset.titel || (document.querySelector('meta[name="title"]') || {}).content || document.title);
		const url = encodeURIComponent(elem.dataset.url || (document.querySelector('link[rel="canonical"]') || {}).href || window.location.href);
		if (typeof optionenKonfiguration.shareUrl != 'function') {
			return '#';
		}
		return optionenKonfiguration.shareUrl(url, titel) || '#';
	}

	window.initTeilen = (container = document.body) => {
		container.querySelectorAll('.teilen-wrapper').forEach(
			/**
			 * @param {HTMLDivElement} elem -
			 * @returns {void}
			 */
			elem => {
				if (elem.dataset.initDone) {
					return;
				}

				const customContentWrapper = elem.closest('.custom-content-wrapper');
				if (!elem.dataset.typ && customContentWrapper) {
					elem.dataset.typ = customContentWrapper.dataset.typ;
				}
				if (!elem.dataset.identifier && customContentWrapper) {
					elem.dataset.identifier = customContentWrapper.dataset.identifier;
				}
				if (!elem.dataset.optionen && customContentWrapper) {
					elem.dataset.optionen = customContentWrapper.dataset.optionen;
				}

				const ohneButton = !!elem.dataset.ohneButton;

				const optionen = elem.dataset.optionen.split(',').filter(o => !!o);
				if (optionen.length) {
					const teilenHauptButton = document.createElement('button');
					if (!ohneButton) {
						teilenHauptButton.type = 'button';
						teilenHauptButton.title = 'Teilen';
						teilenHauptButton.classList.add('teilen-haupt-button');
						teilenHauptButton.innerHTML = '<i class="fa-solid fa-share-nodes"></i>';
					}
					const teilenListe = document.createElement('ul');
					if (ohneButton) {
						teilenListe.classList.add('teilen-liste-ohne-button');
					}
					else {
						teilenListe.classList.add('teilen-liste');
						teilenListe.ariaHidden = true;
					}
					for (const option of optionen) {
						const optionenKonfiguration = optionenKonfigurationen[option];
						if (!optionenKonfiguration) {
							continue;
						}
						if (optionenKonfiguration.nurMobil && window.matchMedia('(pointer: fine)').matches) {
							continue;
						}
						if (option === 'print' && !(window.location.href.includes('/artikel/') || window.location.href.includes('/anzeige/') || window.location.href.includes('/unternehmen/'))) {
							continue;
						}
						const teilenOption = document.createElement('li');
						teilenOption.style.color = optionenKonfiguration.color;
						teilenOption.style.background = optionenKonfiguration.backColor;
						const teilenLink = document.createElement('a');
						if (!ohneButton) {
							teilenLink.tabIndex = -1;
						}
						teilenLink.classList.add('teilen-button');
						teilenLink.rel = 'nofollow';
						teilenLink.role = 'button';
						teilenLink.target = '_blank';
						teilenLink.href = getTeilenLink(elem, optionenKonfiguration);
						teilenLink.title = optionenKonfiguration.titel;
						teilenLink.ariaLabel = optionenKonfiguration.titel;
						teilenLink.innerHTML = `<i class="${optionenKonfiguration.faKlassen}"></i>`;
						teilenOption.append(teilenLink);
						teilenListe.append(teilenOption);
						if (option === 'print') {
							teilenLink.addEventListener('click', evt => {
								if (!ohneButton) {
									// Wenn Koordinaten 0 sind war es sicherlich per Tastatur. Dann muss der Button wieder fokussiert werden damit kein unsichtbares Element fokussiert/aktiviert ist.
									if (evt.clientX + evt.clientY + evt.screenX + evt.screenY + evt.pageX + evt.pageY === 0) {
										teilenHauptButton.focus();
									}
								}
								if ('detailsDrucken' in window && typeof window.detailsDrucken == 'function') {
									evt.preventDefault();
									window.detailsDrucken();
								}
							});
						}
						else {
							teilenLink.addEventListener('click', evt => {
								if (!ohneButton) {
									// Wenn Koordinaten 0 sind war es sicherlich per Tastatur. Dann muss der Button wieder fokussiert werden damit kein unsichtbares Element fokussiert/aktiviert ist.
									if (evt.clientX + evt.clientY + evt.screenX + evt.screenY + evt.pageX + evt.pageY === 0) {
										teilenHauptButton.focus();
									}
								}
								if ('statsErfassen' in window && typeof window.statsErfassen == 'function') {
									let { typ, identifier } = elem.dataset;
									let jjkid = null;
									let jjknr = null;
									if (typ === 'artikel') {
										const identifierInt = parseInt(identifier, 10);
										if (isNaN(identifierInt) || identifierInt.toString() !== identifier) {
											jjkid = -1;
											jjknr = identifier;
										}
										else {
											jjkid = identifierInt;
										}
									}
									else if (typ === 'firmenportrait') {
										jjknr = identifier;
									}
									else if (typ === 'anzeige') {
										jjkid = parseInt(identifier, 10) - 500000000;
									}
									else if (typ === 'kleinanzeige') {
										jjkid = parseInt(identifier, 10) - 100000000;
									}
									else {
										jjkid = parseInt(identifier, 10);
									}
									window.statsErfassen({ typ, wertung: 'share', netzwerk: option, jjkid, jjknr });
								}
							});
						}
					}

					if (teilenListe.childElementCount < 1) {
						return;
					}
					if (!ohneButton) {
						teilenHauptButton.addEventListener('click', () => {
							/** @type {HTMLElement} */
							const offsetParent = teilenHauptButton.offsetParent;
							const offsetParentStyles = window.getComputedStyle(offsetParent);
							const right = offsetParent.offsetWidth - teilenHauptButton.offsetLeft + 10;
							teilenListe.style.top = `${teilenHauptButton.offsetTop + teilenHauptButton.offsetHeight / 2}px`;
							teilenListe.style.right = `${right}px`;
							teilenListe.style.maxWidth = `calc(60% - ${offsetParentStyles.paddingLeft + right}px)`;
							teilenListe.classList.toggle('show');
							teilenListe.ariaHidden = !teilenListe.classList.contains('show');
							teilenListe.querySelectorAll('a').forEach(elem => {
								elem.tabIndex = teilenListe.classList.contains('show') ? 0 : -1;
							});
						});
					}
					elem.append(teilenListe);
					if (!ohneButton) {
						elem.append(teilenHauptButton);
					}

					elem.dataset.initDone = '1';
					elem.parentElement.dataset.hasTeilenWrapper = '1';
				}
			}
		);
	};

	window.initTeilen();
})();
